import { Reducer } from 'react';
import { Wizard } from '../types/wizard';
import { WizardAction, WizardActionType } from '../types/wizard-reducer-actions';

export const wizardReducer: Reducer<Wizard, WizardAction> = (
  state: Wizard,
  action: WizardAction,
) => {
  switch (action.type) {
    case WizardActionType.SET_LOADING_OVERLAY_VISIBLE: {
      return {
        ...state,
        isLoadingOverlayVisible: action.isVisible,
      } as Wizard;
    }
    default:
      return state;
  }
};
